// @owners { team: patient-health }
import { Card, LgPadding } from '@alto/design-system';
import React from 'react';
import { type OrderPricing } from '~shared/features/pricing/types';
import { type OrderPricingQueryData } from '~shared/queries/useOrderPricing';
import { type Prescription } from '~shared/types';
import { useTrackPriceBreakdownViewed } from '../hooks/useTrackPriceBreakdownViewed';
import { PricingBreakdown } from './PricingBreakdown';

type Props = {
  readonly origin: string;
  readonly prescriptions: Prescription[];
  readonly orderPricing?: OrderPricing | OrderPricingQueryData;
};

export const PricingBreakdownCard = ({ origin, orderPricing, prescriptions }: Props) => {
  useTrackPriceBreakdownViewed({ lineItems: orderPricing?.line_items, numberOfRxs: prescriptions.length, origin });

  return (
    <Card>
      <LgPadding>
        <PricingBreakdown
          orderPricing={orderPricing}
          prescriptions={prescriptions}
        />
      </LgPadding>
    </Card>
  );
};
